var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 388,
    viewBox: "0 0 486 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_153_436)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 219,
    ry: 176,
    transform: "matrix(1 0 0 -1 486 194)",
    fill: "#F1FAEE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 229.5,
    ry: 185,
    transform: "matrix(1 0 0 -1 485.5 194)",
    fill: "#F1FAEE",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 238.5,
    ry: 189.5,
    transform: "matrix(1 0 0 -1 485.5 193.5)",
    fill: "#F1FAEE",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 245.5,
    ry: 194,
    transform: "matrix(1 0 0 -1 483.5 194)",
    fill: "#F1FAEE",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 254,
    ry: 198,
    transform: "matrix(1 0 0 -1 480 194)",
    fill: "#F1FAEE",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_153_436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 486,
    height: 388,
    fill: "white",
    transform: "matrix(-1 0 0 1 486 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLight);
export default __webpack_public_path__ + "static/media/loginLight.a8094d21cf257dd19ba1f545d6f4ff17.svg";
export { ForwardRef as ReactComponent };